import React, { useRef, useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color';
import Modal from '../../molecules/modal/modal';
import Button, { ButtonTheme } from '../../atoms/button/button';
import { mapDispatchToProps } from '../../../store/externalCalls/api/uploadFilesApi';
import './colorPickerModal.scss';

const ColorPicker = (props) => {
  const {
    color,
    title,
    onClose,
    currentData,
    alphaAllow
  } = props;
  const childRef = useRef();
  const [disableForm, setDisableForm] = useState(currentData === {});
  const [selectedHexColor, setHexColor] = useState(color);
  const [selectedRGBAColor,setSelectedRGBAColor] =useState(null);
  const [defaultColor, setDefaultColor] = useState({ r: 0, g: 0, b: 0, a: 100 }); // RGBA format
  useEffect(()=>{
    // console.log("alpha",alphaAllow==true?"si":"no");
    if(color){
      setSelectedRGBAColor(hexToRgbaObject(color));
    }else{
      setSelectedRGBAColor(defaultColor);
    }
    
  },[color])
  const handleSave = () => {
    onClose(selectedHexColor);

  };
  const handleClose = () => {
    onClose();
  };
  const handleChangeComplete = (color) => {
    //setHexColor(color.hex);
    setSelectedRGBAColor(color.rgb);
    let hexColor=rgbaObjectToHex(color.rgb);
    setHexColor(hexColor);
  };

  const hexToRgbaObject=(hex)=> {
    console.log(hex);
    // Remove "#" if present
    hex = hex.replace(/^#/, "");

    let r, g, b, a = 255; // Default alpha to 255 (opaque)

    if (hex.length === 6) {
        // HEX without alpha (#RRGGBB)
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
        a = 1; // Fully opaque
    } else if (hex.length === 8) {
        // HEX with alpha (#RRGGBBAA)
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
        a = parseInt(hex.substring(6, 8), 16) / 255; // Convert 00-FF to 0-1 range
    } else {
        throw new Error("Invalid HEX format. Use #RRGGBB or #RRGGBBAA.");
    }

    return { r, g, b, a };
}
const rgbaObjectToHex=({ r, g, b, a = 1 }) =>{
  // Ensure values are within correct range
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  a = Math.max(0, Math.min(1, a)); // Alpha is between 0 and 1

  // Convert each component to a 2-digit hex value
  const toHex = (c) => ("0" + c.toString(16)).slice(-2);

  // Convert alpha to 00-FF format
  const alphaHex = toHex(Math.round(a * 255));

  // Return HEX (include alpha if not fully opaque)
  return a === 1 ? `#${toHex(r)}${toHex(g)}${toHex(b)}` : `#${toHex(r)}${toHex(g)}${toHex(b)}${alphaHex}`;
}

  return (
    <Modal ref={childRef} onClose={handleClose} title={title}>
      <div>
        {/* <HexColorPicker color={color} onChange={setColor} /> */}
        {selectedRGBAColor && <SketchPicker width={450} disableAlpha={!alphaAllow} color={selectedRGBAColor} onChangeComplete={handleChangeComplete} />}

      </div>
      <div>
        <Button
          onClick={handleSave}
          disabled={disableForm}
          theme={ButtonTheme.PRIMARY}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

ColorPicker.propTypes = {
  /**
   * formtype
   */
  color: PropTypes.string.isRequired,
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Event callback when the modal is closed
   */
  onClose: PropTypes.func,

  /**
   * initial data values
   */
  currentData: PropTypes.shape({}),
};

ColorPicker.defaultProps = {
  title: '',
  onClose: () => {},
  currentData: {},
};

export default connect(null, mapDispatchToProps)(ColorPicker);
